// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2zYo1","fileBtn":"File_fileBtn__1HKCR","closeBtn":"File_closeBtn__3mXba","fileSelected":"File_fileSelected__3S1mF","disabled":"File_disabled__2pBBO"};